import { apiRequest } from '@/utils/api-request';

export interface GeneralChatSession {
  chat_socket_url: string;
}

export interface CreateGeneralChatSessionParams {
  nodeType: string;
  nodeName: string;
  model: string;
  orgId?: string;
}

export const createGeneralChatSession = async ({
  nodeType,
  nodeName,
  model,
  orgId = '',
}: CreateGeneralChatSessionParams) => {
  const response = await apiRequest<GeneralChatSession>({
    url: '/session/create-general-chat-session',
    method: 'POST',
    target: 'workflow',
    body: {
      node_type: nodeType,
      node_name: nodeName,
      model,
      org_id: orgId,
    },
  });
  return response.data;
};
